function Nav() {
    this.build();

}

Nav.prototype.build = function(){

    $('.header-toggle').on('click',function(){
        $('body').toggleClass('nav-main-open').removeClass('subnav-main-open');
        $('.subnav-open').removeClass('subnav-open');
    });

    $('.header-subnav-toggle').on('click',function(){
        $('body').removeClass('subnav-main-open');
        $('.subnav-open').removeClass('subnav-open');
    });

    let fromTop = $('.header-main').innerHeight();
    gsap.to( $('.header-main-bg'), {
        y: 0,
        ease: 'none',
        scrollTrigger: {
            trigger: $('.scroll-content'),
            start: 'top top',
            end : fromTop,
            scrub: true
        }
    });

    if (hasTouch) {
        $('.menu-item--lev1 > a').on('click', function(e){
           if( $(this).next('ul').length > 0 ){
               $('body').toggleClass('subnav-main-open');
               $(this).parent('li').toggleClass('subnav-open');
           }
        });
    }

    if(mobileCheck.isMobile && hasTouch){
        $('.breadcrumbs-main').on('click', function(e){
            if(!$(e.target).hasClass('breadcrumbs-secondary-close') ) {
                $('.breadcrumbs-secondary').toggleClass('breadcrumbs-secondary--is-open');
                $('.breadcrumbs-main a').on('click', function (e) {
                    e.preventDefault();
                });
            }
        });
        $('.breadcrumbs-secondary-close').on('click', function(e){
            $('.breadcrumbs-secondary').removeClass('breadcrumbs-secondary--is-open');
        });
    }

};
